import * as types from '../action-types';
import { DecisionSelectionReducerType } from '../decisionState.types';
import { DecisionSelectionActions } from '../actions';

const initialState: DecisionSelectionReducerType = {
  selectedText: '',
  textSelection: {
    startWord: '',
    endWord: '',
    startWordOccurrence: 0,
    endWordOccurrence: 0,
    selectedString: '',
    length: 0,
    startWordPosition: 0,
  },
  selectionId: null,
};

export function decisionSelectionReducer(
  state: DecisionSelectionReducerType = initialState,
  action: DecisionSelectionActions,
) {
  switch (action.type) {
    case types.storeSelectedText: {
      const { selectedText } = action.payload;
      return {
        ...state,
        selectedText,
        textSelection: { ...state.textSelection },
      };
    }
    case types.storeTextSelection: {
      const { textSelection } = action.payload;
      if (textSelection) {
        return { ...state, textSelection };
      }
      return state;
    }
    case types.storeSelectionId: {
      const { selectionId } = action.payload;
      return { ...state, selectionId };
    }
    default: {
      return state;
    }
  }
}
